module.exports = __webpack_public_path__ + "static/media/screenshots.0eae397b.png";